// Function to handle social media sharing
export const handleShare = (platform) => {
    const currentUrl = window.location.href; // Get the current page URL
    let shareUrl = '';

    switch (platform) {
        case 'facebook':
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
            break;
        case 'twitter':
            shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`;
            break;
        case 'linkedin':
            shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`;
            break;
        default:
            console.error('Unsupported platform:', platform);
            return;
    }

    // Open the sharing URL in a new tab
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
};